import { LOGOUT } from "@/components/access/ducks/Actions"
import { RECEIVE_ROLE_DONATION_STATS } from "@/components/donations/volunteer/ducks/Actions"

const defaultState = {
  donationStats: [],
}

const volunteerDonationsReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case LOGOUT:
      return defaultState

    case RECEIVE_ROLE_DONATION_STATS:
      return {
        ...oldState,
        donationStats: action.stats,
      }

    default:
      return oldState
  }
}

export default volunteerDonationsReducer
